import { Component, OnInit } from '@angular/core';
import { BankAccountAchModel } from '../../../data/model/BankAchModel/bankaccountAch.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataManagerService } from '../../../data/services/DataManager/data-manager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdateBankAccountAction } from './update-bank-account.action';
import { AppConstants } from '../../../shared/constants/app-constants';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'app-edit-bank-account',
    templateUrl: './edit-bank-account.component.html',
    styleUrls: ['./edit-bank-account.component.css'],
    standalone: false
})
export class EditBankAccountComponent extends UpdateBankAccountAction implements OnInit {
  topErrorMessage: string;
  errorMsgFlag: boolean;
  bankAccount:BankAccountAchModel;
  keys: string[];
  keys1: string[];
  errorMsg: string;
  bankAccountId: string;
  bankAccountCustId: string;
  editBankAccountForm:UntypedFormGroup;
  categories: string[] = ['Personal Checking', 'Personal Savings', 'Business Checking', 'Business Savings' ];

  constructor(dataManager:DataManagerService,private fb:UntypedFormBuilder, route:ActivatedRoute,router:Router,snackBar:MatSnackBar) {
    super();
     this._editBankAccountToCustomerUrl=AppConstants.BASE_URL + AppConstants.SERVICE_NAME_ACH_DETAILS;
     this.errorMsgFlag = false;
     this.dataManager = dataManager;
    this.bankAccount = new BankAccountAchModel();
    this.router =router;
    this.route =route;
    this.snackBar =snackBar;
    this.bankAccountId = this.route.snapshot.queryParams.id;
    this.bankAccountCustId = this.route.snapshot.queryParams.cust_id;

  }
  
  
  ngOnInit(): void {

    this.editBankAccountForm=this.fb.group({
      account_number: [{value:'',disabled:true}, [ (Validators.maxLength(17) as any)]],
      routing_number: [{value:'',disabled:true}, [ (Validators.maxLength(9) as any),Validators.pattern(/^[0-9]+$/)]],
      first_name: ['', [(Validators.required as any), (Validators.maxLength(50) as any)]],
      last_name: ['',[(Validators.required as any),(Validators.maxLength(50) as any)]],
      account_type: ['', [(Validators.required as any)]],
    })
    this.loadBankAccountInfo(this.bankAccountId);
  }



  protected  passResponseAccountInfo(response) {
      this.bankAccount = response.data;
      this.editBankAccountForm.patchValue(this.bankAccount);
      this.loadFlag = false;
  };
  protected  passSourceResponse(res) {

  };
  protected  passSourceError(error) {

  };
  protected  passResponse(response) {
    this.goBackToDetails();
    this.showSnackBar('Customer editd successfully.', 'Ok', 3000);
    
  };
 
  protected  passError(error) {
    this.errorMsg = error.message;
    this.topErrorMessage = error.errors;
    this.keys = Object.keys(this.topErrorMessage);
    this.errorMsgFlag = true;
    this.keys1 = Object.values(this.topErrorMessage);
  };

  editBankAccount(){
    this._editBankAccountToCustomerUrl=this._editBankAccountToCustomerUrl + '/' + this.bankAccountId;
    this.editBankAccountOnApi(this.editBankAccountForm.value);
  }

  cancelBankAccount() {
    this.goBackToDetails();
  }
  goBackToDetails() {
    this.router.navigate(['../customer-details'], {queryParams: {id: this.bankAccountCustId},relativeTo : this.route});
  }
  
  loadBankAccountInfo(accInfo) {
    this.getAddress(this._editBankAccountToCustomerUrl + '/' + accInfo);
    
  }
}
